import React, {useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import {Box, CircularProgress} from '@mui/material'
import {useToast} from 'src/components-new/feedback/ToastProvider'
import apiClient from 'src/services/apiClient'
import {PATHS} from 'src/constants/constants'

type LatestWebPush = {
  type: 'assumption-reminder' | 'activity-planned' | 'activity-cancelled'
  secondaryAssumptionId?: string
  activityId?: string
  plannedDate?: string
}

// Same targets the service worker gives a notification it could read (public/service-worker.js,
// describeReminder/describeActivity).
function targetOf(latest: LatestWebPush): string | undefined {
  if (latest.type === 'assumption-reminder') {
    return latest.secondaryAssumptionId ? `/secondary-assumptions/${latest.secondaryAssumptionId}` : undefined
  }
  const params = new URLSearchParams()
  if (latest.activityId) params.set('activityId', latest.activityId)
  if (latest.plannedDate) params.set('date', latest.plannedDate)
  const query = params.toString()
  return query ? `${PATHS.AGENDA}?${query}` : PATHS.AGENDA
}

// Fallback target of a click on a web push notification (public/service-worker.js), when the
// notification could not tell what it was for (e.g. the session had expired when it arrived, and
// the click went through the login): opens the dose the patient was reminded of last - the same
// confirmation page the mail/SMS link points at - or the activity whose change was notified last.
// With nothing to open, it goes to the homepage.
export default function LatestReminderRedirectNew(): JSX.Element {
  const history = useHistory()
  const toast = useToast()

  useEffect(() => {
    let cancelled = false

    const goHome = () => {
      toast.info('Non ci sono promemoria da aprire.')
      history.replace('/')
    }

    apiClient.getLatestWebPush()
      .then((latest: LatestWebPush) => {
        if (cancelled) return
        const target = targetOf(latest)
        if (target) {
          history.replace(target)
        } else {
          goHome()
        }
      })
      .catch((error: any) => {
        if (cancelled) return
        if (error?.response?.status === 404) {
          goHome()
          return
        }
        toast.error('Non è stato possibile aprire il promemoria.')
        history.replace('/')
      })

    return () => { cancelled = true }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh'}}>
      <CircularProgress />
    </Box>
  )
}
